<!-- =========================================================================================
    File Name:
    Description:
    ----------------------------------------------------------------------------------------
    Item Name: GetBoarded UI Template
    Author: GetBoarded
    Author URL: https://www.getboarded.com
========================================================================================== -->

<template>
  <div id="page-user-list">
    <!-- Add User and Send Invite -->
    <div class="demo-alignment">
      <vs-button class="primary" @click="activePrompt = true" type="filled"
        >{{$t('AssignCoach')}}</vs-button
      >
    </div>

    <!-- Add User Prompt -->



    <vs-prompt
      :title="$t('AssignCoach')"
      :accept-text="$t('Submit')"
      :cancel-text="$t('Cancel')"
      @cancel="clearFields"
      @accept="assignCoach"
      @close="clearFields"
      :is-valid="validateEmail"
      :active.sync="activePrompt"



    >
<div>


    <form @submit.prevent style="height: 180px;">

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full mt-8">
          <span>{{$t('Coachee')}}</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full mt-8">
          <component
              :is="scrollbarTag"
              class="scroll-area "
              :settings="settings"
              :key="$vs.rtl"
          >
          <v-select
              v-model="trainee"
              label="label"
              :options="trainee_list"
          ></v-select>
          </component>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full mt-12">
          <span>{{$t('Coach')}}</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full mt-12">
          <component
              :is="scrollbarTag"
              class="scroll-area  "
              :settings="settings"
              :key="$vs.rtl"
          >    <v-select
              v-model="coach"
              label="label"
              :options="coach_list"
          ></v-select>
          </component>
        </div>
      </div>
    </form>

</div>

    </vs-prompt>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { models } from "feathers-vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import i18n from "@/i18n/i18n";
// import ccd from "@/assets/data/charactersistic-competency-definition.js";

export default {
  name: "SendInvite",
  components: {
    VuePerfectScrollbar,
    vSelect
  },
  data() {
    return {
      CCD: this.$t("addNewSkill.data"),
      trainee: null,
      trainee_competency: null,
      coach: null,
      trainee_list: [],
      trainee_competency_list: [],
      coach_list: [],
      activePrompt: false,
      settings: {
        maxScrollbarLength: 0,
        wheelSpeed: 0.3
      }
    };
  },
  watch: {},
  computed: {
    validateEmail() {
      return !this.errors.any() && this.user_email !== "";
    },
    scrollbarTag() {

      return this.$store.getters.scrollbarTag;
    }
  },
  methods: {
    fetchTraineeCompetency() {
      // Fetch All Trainee Competencies
      this.$store
        .dispatch("trainee-competencies/find", {query: {usersId: this.trainee.id}})
        .then(res => {
          if(res.total > 0) {
            this.trainee_competency_list = res.data;
            console.log("trainee competency list", this.trainee_competency_list);
            for(const tc in res.data) {
              const competency_id = (this.trainee_competency_list[tc]["competencyId"]).split("-")
              this.trainee_competency_list[tc]["label"] = this.CCD[competency_id[0]].competencies[competency_id[1]].comp
            }
          }
        })
        .catch(err => {
          console.log("could not find trainee competencies", err);
        });

      console.log(this.trainee, this.coach, this.trainee_competency)
    },
    printValues() {
      console.log(this.trainee, this.coach, this.trainee_competency)
    },
    clearFields() {
      this.$nextTick(() => {
        this.user_email = "";
      });
    },
    assignCoach() {
      // console.log('models', models)
      let trainee_coach={};
      if(this.trainee.id===this.coach.id){
        this.$vs.notify({
          title: i18n.t('notification.admin.assignCoach.coachAssigned.warning.f1'),
          text:  i18n.t('notification.admin.assignCoach.coachAssigned.warning.f2'),
          color: "danger"
        });

      }
      else{
        if(window.$cookies.get('companyId')) {
          trainee_coach = {
            traineeId: this.trainee.id,
            coachId: this.coach.id,
            companyId:window.$cookies.get('companyId'),
            status: 'active'
          };
        }else{
          trainee_coach = {
            traineeId: this.trainee.id,
            coachId: this.coach.id,
            status: 'active'
          };
        }

        console.log("model", trainee_coach);

        this.$store
          .dispatch("traineeCoachAssignment/assignTraineeCoach", trainee_coach)
          .then(res => {
            console.log("trainee assigned to coach", res);
            this.$vs.notify({
              title: i18n.t('notification.admin.assignCoach.coachAssigned.success.s1'),
              text:  i18n.t('notification.admin.assignCoach.coachAssigned.success.s2'),
              color: "primary"
            });
            
            // 1. Emit success event to parent component
            this.$emit('on-success');
            
            // 2. Close the prompt modal
            this.activePrompt = false;
          })
          .catch(err => {
            console.log("coach assignment failed", err);
            this.$vs.notify({
              title: i18n.t('notification.admin.assignCoach.coachAssigned.failed.f1'),
              text:  i18n.t('notification.admin.assignCoach.coachAssigned.failed.f2'),
              color: "warning"
            });
          });
      }
    }
  },
  mounted () {},
  created () {
    // Fetch All Trainees
    let traineeQuery={};
    if(window.$cookies.get('companyId')){
       traineeQuery = {
        status: {
          $ne: 'deleted'
        },
        userType: "trainee",
        companyId:window.$cookies.get('companyId')
      }
    }else {
       traineeQuery = {
        status: {
          $ne: 'deleted'
        },
        userType: "trainee"
      }
    }
    this.$store
      .dispatch("userManagement/fetchUsers", {query: traineeQuery})
      .then(res => {
        this.trainee_list = res.data;
        console.log("trainee list", this.trainee_list);
        for(const t in res.data) {
          this.trainee_list[t]["label"] = `${this.trainee_list[t]["firstName"]  } (${  this.trainee_list[t]["email"]  })`
          this.trainee_list[t]["value"] = this.trainee_list[t]["id"]
        }
      })
      .catch(err => {
        console.log("could not find trainees", err);
      });

    // Fetch All Coaches
    let coachQuery={};
    if(window.$cookies.get('companyId') && window.$cookies.get('organizationType')!=='Academic'){
      coachQuery = {
        status: {
          $ne: 'deleted'
        },

        companyId:window.$cookies.get('companyId')
      }
      this.$store
          .dispatch("users/find", {query: coachQuery})
          .then(res => {
            this.coach_list = res.data;
            console.log("coach list", this.coach_list);
            for(const t in res.data) {
              this.coach_list[t]["label"] = `${this.coach_list[t]["firstName"]  } (${  this.coach_list[t]["email"]  })`
              this.coach_list[t]["value"] = this.coach_list[t]["id"]
            }
          })
          .catch(err => {
            console.log("could not find coaches", err);
          });
    }
    else if(window.$cookies.get('organizationType')==="Academic"){
      coachQuery = {
        status: {
          $ne: 'deleted'
        },
        userType:'coach',

        companyId:window.$cookies.get('companyId')
      }
      this.$store
          .dispatch("users/find", {query: coachQuery})
          .then(res => {
            this.coach_list = res.data;
            console.log("coach list", this.coach_list);
            for(const t in res.data) {

                this.coach_list[t]["label"] = `${this.coach_list[t]["firstName"]  } (${  this.coach_list[t]["email"]  })`
                this.coach_list[t]["value"] = this.coach_list[t]["id"]

            }
          })
          .catch(err => {
            console.log("could not find coaches", err);
          });
    }
    else {
       coachQuery = {
        status: {
          $ne: 'deleted'
        },

      }
      this.$store
          .dispatch("users/find", {query: coachQuery})
          .then(res => {
            this.coach_list = res.data;
            console.log("coach list", this.coach_list);
            for(const t in res.data) {
              this.coach_list[t]["label"] = `${this.coach_list[t]["firstName"]  } (${  this.coach_list[t]["email"]  })`
              this.coach_list[t]["value"] = this.coach_list[t]["id"]
            }
          })
          .catch(err => {
            console.log("could not find coaches", err);
          });
    }

  }
};
</script>

<style lang="scss" scoped>

.scroll-area {
  position: absolute;
  margin: auto;
  width: 300px;
  height: 100%;
  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
